import { Table } from "reactstrap";
import { UserInformationTableHead } from "./UserInformationTableHead";
import { UserInformationTableBody } from "./UserInformationTableBody";

export const UserInformationTable = () => {
  return (
    <Table className="display dataTable" id="information">
      <UserInformationTableHead />
      <UserInformationTableBody />
    </Table>
  );
};
